import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterConsumptionProductionDto } from "../../../../api";
import { WaterConsumptionProductionColumns } from "../form/columns";

interface WaterConsumptionProductionFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterConsumptionProduction: (values: CreateWaterConsumptionProductionDto) => void;
}

export const WaterConsumptionProductionForm: React.FC<WaterConsumptionProductionFormProps> = ({ visible, setVisible, onCreateWaterConsumptionProduction }) => {
  const [form] = Form.useForm<CreateWaterConsumptionProductionDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterConsumptionProduction}>
        {WaterConsumptionProductionColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
